import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { NgModule } from '@angular/core'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { ArpioRoutingModule } from './arpio-routing.module'
import { ArpioRootComponent } from './components/arpio-root/arpio-root.component'
import { TestPageComponent } from './components/test-page/test-page.component'
import { AccountModule } from 'src/app/account/account.module'
import { ArpioAlertModule } from './arpio-alert/arpio-alert.module'
import { ReadOnlyPreviewDirective } from './components/test-page/shared/read-only-preview.directive'
import { ShowcaseScreenPreviewComponent } from './components/test-page/shared/screen-preview/showcase-screen-preview.component'
import { ShowcaseStatusBarComponent } from './components/test-page/shared/status-bar/showcase-status-bar.component'
import { ShowcaseTabBarActionsComponent } from './components/test-page/shared/tab-bar-actions/showcase-tab-bar-actions.component'
import { ShowcaseBannersComponent } from './components/test-page/sections/banners/showcase-banners.component'
import { ShowcaseBackupScreenComponent } from './components/test-page/sections/backup-screen/showcase-backup-screen.component'
import { ShowcaseChartComponent } from './components/test-page/sections/chart/showcase-chart.component'
import { ShowcaseErrorsComponent } from './components/test-page/sections/errors/showcase-errors.component'
import { ShowcaseIssueScenariosComponent } from './components/test-page/sections/issue-scenarios/showcase-issue-scenarios.component'
import { ShowcaseIssuesComponent } from './components/test-page/sections/issues/showcase-issues.component'
import { ShowcaseLegacyTemplatesComponent } from './components/test-page/sections/legacy-templates/showcase-legacy-templates.component'
import { ShowcaseModalsComponent } from './components/test-page/sections/modals/showcase-modals.component'
import { ShowcaseRecoveryScreenComponent } from './components/test-page/sections/recovery-screen/showcase-recovery-screen.component'
import { ShowcaseResourcesComponent } from './components/test-page/sections/resources/showcase-resources.component'
import { ShowcaseRetentionComponent } from './components/test-page/sections/retention/showcase-retention.component'
import { ShowcaseStacksetsComponent } from './components/test-page/sections/stacksets/showcase-stacksets.component'
import { ShowcaseTabStatusComponent } from './components/test-page/sections/tab-status/showcase-tab-status.component'
import { ShowcaseTooltipsComponent } from './components/test-page/sections/tooltips/showcase-tooltips.component'
import { ShowcaseUsageBillingComponent } from './components/test-page/sections/usage-billing/showcase-usage-billing.component'

// Showcase sections are declared here rather than made standalone: a standalone
// section would need `imports: [AccountModule]`, whose child environment injector
// re-instantiates BrowserModule (re-exported by ArpioSharedModule) and throws
// NG5100. Same trap documented in admin.module.ts.
const SHOWCASE_DECLARATIONS = [
  ReadOnlyPreviewDirective,
  ShowcaseScreenPreviewComponent,
  ShowcaseStatusBarComponent,
  ShowcaseTabBarActionsComponent,
  ShowcaseBackupScreenComponent,
  ShowcaseBannersComponent,
  ShowcaseChartComponent,
  ShowcaseErrorsComponent,
  ShowcaseIssueScenariosComponent,
  ShowcaseIssuesComponent,
  ShowcaseLegacyTemplatesComponent,
  ShowcaseModalsComponent,
  ShowcaseRecoveryScreenComponent,
  ShowcaseResourcesComponent,
  ShowcaseRetentionComponent,
  ShowcaseStacksetsComponent,
  ShowcaseTabStatusComponent,
  ShowcaseTooltipsComponent,
  ShowcaseUsageBillingComponent,
]

@NgModule({
  declarations: [ArpioRootComponent, TestPageComponent, ...SHOWCASE_DECLARATIONS],
  // ArpioSharedModule imports the forms modules without re-exporting them, so a showcase
  // section that hosts its own form (Errors, Modals) needs this directly.
  imports: [CommonModule, ReactiveFormsModule, ArpioRoutingModule, ArpioSharedModule, AccountModule, ArpioAlertModule],
})
export class ArpioModule {}
